//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    slides: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    swiperOptions: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
  }),
  computed: {
    swiper() {
      return this.$refs.imgSlider.$swiper;
    },
  },
};
